import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.typed.uint8-array";
import axios from "axios";

var createBaseUrl = function createBaseUrl(user_id) {
  var timeStamp = new Date().valueOf();
  return "https://camera-resource.s3.amazonaws.com/upload/celebrity/".concat(user_id, "/similar/").concat(timeStamp, "_").concat(user_id, ".jpg");
};

var convertBase64UrlToBlob = function convertBase64UrlToBlob(urlData) {
  var mime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "image/jpg";
  var bstr = atob(urlData);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new Blob([u8arr], {
    type: mime
  });
};

var blobToFile = function blobToFile(theBlob, fileName) {
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
};
/**
 * Aws上传全家桶
 * @param user_id
 * @param base64
 */


export var awsUpload =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(user_id, base64) {
    var blob, file, REQ_URL, options, res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            blob = convertBase64UrlToBlob(base64);
            file = blobToFile(blob, "photo.jpg");
            console.log("file:", file);
            REQ_URL = createBaseUrl(user_id);
            options = {
              headers: {
                "Content-Type": file.type
              }
            };
            _context.next = 8;
            return axios.put(REQ_URL, file, options);

          case 8:
            res = _context.sent;
            console.log("awsUpload:", res);
            res.data = REQ_URL;
            return _context.abrupt("return", res);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            console.log("awsUpload error:", _context.t0);
            return _context.abrupt("return", _Promise.reject(_context.t0));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function awsUpload(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();